export default __webpack_public_path__ + "static/media/Glodani 9.1bbadc68.jpg";